import styled from 'styled-components';
import { OnlineThemeType } from '../../themes/online';

const setRightIcon = (clickable: boolean, showPanel: boolean, theme: OnlineThemeType) => {
  if (clickable) {
    return `
              &:after {
                  content: '';
                  background-image: url(${showPanel ? theme.icons.arrowUp : theme.icons.arrowDown});
                  background-repeat: no-repeat;
                  background-position: center;
                  width: 30px;
                  height: 30px;
                  position: absolute;
                  right: 30px;
              }
          `;
  }

  return '';
};

export const SAccordionContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

export const SAccordionButton = styled.button<{
  clickable: boolean;
  showPanel: boolean;
  bgColor: string;
}>(({ theme, clickable, showPanel, bgColor }) => {
  return `
      background-color: ${bgColor || '#eee'};
      color: #444;
      cursor: pointer;
      padding: 18px;
      width: 100%;
      text-align: left;
      border: none;
      outline: none;
      transition: 0.4s;
      align-self: center;
      line-height: 1.05;
      font-size: ${theme.font.size.smallMedium3};
      font-weight: ${theme.font.weight.bold};
      margin-bottom: ${showPanel ? '20px' : 0};
      padding-left: 13px;

      ${setRightIcon(clickable, showPanel, theme)};
    `;
});
export const SPanel = styled.div<{
  show: boolean;
  panelBackgroundColor: string;
}>(({ show, panelBackgroundColor }) => {
  return `
      background-color: ${panelBackgroundColor || 'transparent'};
      display: ${show ? 'flex' : 'none'};
      flex-direction: column;
      margin-bottom: 20px;
      `;
});
export const SIconBox = styled.span`
  margin-right: 13px;
`;
